import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { setActiveCateIdAction, addDelCate3ListAction, removelCate3ListAction } from '../../modules/common/cateModule';
import { useDispatch, useSelector } from 'react-redux';
import { remove, uniq, filter, forEach, isEqual } from 'lodash';
import TagBtn from './button/TagBtn';
import { setPriceAction } from '../../modules/common/prodModule';
import { setCurPageAction } from '../../modules/common/cateModule';
import { useHistory } from 'react-router-dom';
import {isMobileOnly} from 'react-device-detect';

const Cate3DepListBlock = styled.div`
  ${isMobileOnly&&`
      .tf-list {
        display:flex;
        flex-wrap:wrap;
        align-items: flex-start;
      }      
  `};
`;

const Cate3DepList = ({ title, evtHandler }) => {

    const [checkedCate, setCheckedCate] = useState([]);
    const [allChecked, setAllChecked] = useState(false);
    const [delCnt, setDelCnt] = useState(0);

    const dispatch = useDispatch();
    const history = useHistory();

    const { activeCateIds, cate3depItems, delCate3Ids } = useSelector(
        ({ cateItemsReducer }) => ({
            activeCateIds: cateItemsReducer.activeCateIds,
            cate3depItems: cateItemsReducer.cate3depItems,
            delCate3Ids: cateItemsReducer.delCate3Ids,
        })
    );

    useEffect(() => {
        // console.log("Cate3DepList ------------> 1 이거 불릴까?")
        makeActiveCateItems();
    }, [cate3depItems, delCate3Ids]);

    // console.log("Cate3DepList ------------> 3" + JSON.stringify(delCate3Ids));


    // active, deactive 카테고리 상태를 설정
    const makeActiveCateItems = () => {
         //console.log("makeActiveCateItems called !!!")
        if (cate3depItems !== null) {
            // 3Depth 카테고리 아이디 만들기
            let cateIdList = cate3depItems.reduce((resultObj, curObj, idx) => {
                const cateid = (curObj.cate1_id * 10000) + (curObj.cate2_id * 100) + curObj.cate3_id * 1;
                resultObj.push(cateid);
                return resultObj;
            }, []);

            // 삭제된 카테고리아이디를 제거하여 active 표시
            // console.log("delCate3Ids : " + cateIdList);
            remove(cateIdList, (item) => {
                return (delCate3Ids.indexOf(item) >= 0);
            });
            // let tmpCateId = delCate3Ids.filter(x => cateIdList.indexOf(x) === -1);
            // console.log("cateIdList : " + cateIdList)
            setDelCnt(delCate3Ids === null ? 0 : delCate3Ids.length);
            setCheckedCate(cateIdList);
            setAllChecked((cateIdList.length === cate3depItems.length));
            let uniqueCateIds = [...new Set(activeCateIds.concat(cateIdList))];
            dispatch(setActiveCateIdAction(uniqueCateIds));
        }
    }

    if (delCnt !== delCate3Ids.length) {
        makeActiveCateItems();
    }

    // Filter Active 상태 확인
    const checkActive = (cateid) => {

        if (allChecked) return false;

        if (checkedCate === null || checkedCate.length === 0) {
            return false;
        } else {
            return (checkedCate.indexOf(cateid) !== -1);
        }
    }

    // const handleCateClick = (cateid) => {
    //
    //     // 가격 초기화
    //     /* dispatch(setPriceAction({ min: 0, max: 0 }));
    //     dispatch(setCurPageAction(1)); */
    //     let activeCate = [...checkedCate];
    //
    //     const state = { ...history.location.state };
    //     state.prodPrice = { min: 0, max: 0 };
    //     state.curPageNum = 1;
    //     let delCate = state.delCate3Ids;
    //
    //     // All Check 된 상테에서 cateid 를 선택한 경우에는 모두 제거후 추가 처리
    //     if (allChecked) {
    //         forEach(activeCate, (curitem) => {
    //
    //             remove(activeCateIds, (obj) => {
    //                 return obj === curitem;
    //             })
    //             // redux 삭제 리스트에 저장
    //             dispatch(addDelCate3ListAction(curitem));
    //             delCate.push(curitem);
    //         })
    //         activeCate = [];
    //
    //         // 추가
    //         activeCate.push(cateid);
    //         activeCateIds.push(cateid);
    //
    //         // redux 삭제 리스트에서 제거
    //         dispatch(removelCate3ListAction(cateid));
    //
    //         let srcIds = delCate;
    //             remove(srcIds, (curitem) => {
    //                 return (curitem === cateid)
    //             })
    //
    //         state.delCate3Ids = srcIds;
    //
    //     } else {
    //         // Check 처리 된 항목의 경우 삭제 하여 비체크 처리
    //         if (checkActive(cateid)) {
    //             // 1개만 남았을 경우에는 반응하지 않음
    //             if (activeCate.length <= 1) {
    //                 return
    //             }
    //
    //             remove(activeCate, (obj) => {
    //                 return obj === cateid;
    //             })
    //
    //             remove(activeCateIds, (obj) => {
    //                 return obj === cateid;
    //             })
    //
    //             // redux 삭제 리스트에 저장
    //             dispatch(addDelCate3ListAction(cateid));
    //             delCate.push(cateid);
    //
    //         } else {
    //             // 추가
    //             activeCate.push(cateid);
    //             activeCateIds.push(cateid);
    //
    //             // redux 삭제 리스트에서 제거
    //             dispatch(removelCate3ListAction(cateid));
    //
    //             let srcIds = delCate;
    //             remove(srcIds, (curitem) => {
    //                 return (curitem === cateid)
    //             })
    //
    //             state.delCate3Ids = srcIds;
    //
    //         }
    //     }
    //
    //     setCheckedCate(activeCate);
    //
    //     // console.log("activeCateIds: " + JSON.stringify(activeCateIds));
    //
    //     // Redux 에 선택된 cate id 저장
    //     let uniqueCateIds = uniq(activeCateIds);
    //     /* dispatch(setActiveCateIdAction(uniqueCateIds)); */
    //
    //     state.activeCateIds = uniqueCateIds;
    //     history.replace({ ...history.location, state });
    //
    //     // console.log("uniqueCateIds: " + JSON.stringify(uniqueCateIds));
    //
    //     // check count 와 전체 카운트가 같으면 All Check
    //     setAllChecked((activeCate.length === cate3depItems.length));
    // }

    const handleCateClick = (cateid) => {

        // 가격 초기화
        let activeCate = [...checkedCate];

        // All Check 된 상테에서 cateid 를 선택한 경우에는 모두 제거후 추가 처리
        if (allChecked) {
            forEach(activeCate, (curitem) => {

                remove(activeCateIds, (obj) => {
                    return obj === curitem;
                })
                // redux 삭제 리스트에 저장
                dispatch(addDelCate3ListAction(curitem));
                // delCate.push(curitem);
            })
            activeCate = [];


            // redux 삭제 리스트에서 제거
            dispatch(removelCate3ListAction(cateid));

            // console.log('@@@@@@@@@@',activeCateIds, delCate3Ids)

        } else {
            // Check 처리 된 항목의 경우 삭제 하여 비체크 처리
            if (checkActive(cateid)) {
                // 1개만 남았을 경우에는 반응하지 않음
                if (activeCate.length <= 1) {
                    return
                }

                remove(activeCate, (obj) => {
                    return obj === cateid;
                })
                //
                // redux 삭제 리스트에 저장
                dispatch(addDelCate3ListAction(cateid));
                // console.log('uncheck',activeCateIds,delCate3Ids)

            } else {
                // 추가
                activeCate.push(cateid);
                // activeCateIds.push(cateid);

                // redux 삭제 리스트에서 제거
                dispatch(removelCate3ListAction(cateid));

            }
        }

        setCheckedCate(activeCate);

        // console.log("activeCateIds: " + JSON.stringify(activeCateIds));
        // check count 와 전체 카운트가 같으면 All Check
        setAllChecked((activeCate.length === cate3depItems.length));
    }

    // 전체 선택한 경우
    const handleAllCheckClick = (isForce) => {

        // 전체 선택된 상태의 경우 반응하지 않음
        if (!allChecked || isForce) {
            let cateIdList = cate3depItems.reduce((resultObj, curObj, idx) => {
                const cateid = (curObj.cate1_id * 10000) + (curObj.cate2_id * 100) + curObj.cate3_id * 1;
                resultObj.push(cateid);
                dispatch(removelCate3ListAction(cateid))
                return resultObj;
            }, [])

            setCheckedCate(cateIdList);
            setAllChecked(true);
            // 탭 이동시 이전 선택 정보가 남아 있어야 하므로 합치고, 중복 제거 후 Redux 에 저장
            // let uniqueCateIds = [...new Set(activeCateIds.concat(cateIdList))];
            /* dispatch(setActiveCateIdAction(uniqueCateIds));*/
            //전체 선택시 분류 초기화
            dispatch(removelCate3ListAction(-1));
            // console.log('ALL CHECK',activeCateIds,delCate3Ids)
            // const state = { ...history.location.state };
            // state.prodPrice = { min: 0, max: 0 };
            // state.curPageNum = 1;
            // state.delCate3Ids = [];
            // state.activeCateIds = uniqueCateIds;
            // history.replace({ ...history.location, state });

        }
    }

    const itemMargin = isMobileOnly?{marginLeft: '10px', marginTop: '18px'}:{marginLeft: '40px', marginTop: '18px'};
    return (
        <Cate3DepListBlock>
            <div className="tf-item clearfix">
                <span className="tf-title">{title}</span>
                <ul className="tf-list clearfix">
                    <li>
                        <TagBtn active={allChecked}
                            float='left' onClick={handleAllCheckClick}
                            onDelClick={handleAllCheckClick}
                            text='전체' isSmall={true} value={false}
                            noDelBtn={true}
                        />
                    </li>
                    {
                        (cate3depItems === null) ? (<li> loading ... </li>) :
                            (
                                cate3depItems.map((cateitem) => {
                                    const cateid = (cateitem.cate1_id * 10000) + (cateitem.cate2_id * 100) + cateitem.cate3_id;
                                    const name = cateitem.cate_name;
                                    return (
                                        <li key={cateid} style={itemMargin}>
                                            <TagBtn
                                                active={checkActive(cateid)}
                                                float='left'
                                                onClick={handleCateClick}
                                                onDelClick={handleCateClick}
                                                text={name} isSmall={true} value={cateid}
                                            />
                                        </li>
                                    );
                                })
                            )
                    }
                </ul>
            </div>
        </Cate3DepListBlock>
    );
};

export default Cate3DepList;
